import React from 'react';
import PropTypes from 'prop-types';
import { FormattedText, formatText } from 'core/i18n';
import MessagesScreen from 'components/messagesScreen/messagesScreen';

const PostOfficeSuccessView = ({ handleFinishIdentity }) => {
    return (
        <div className="main-container messages-main-container basic-layering">
            <MessagesScreen
                iconClass="icons icons--icon-success-blue"
                title={formatText('messagesScreen-correosFinishTitle')}
                buttonText={formatText('button-continue')}
                showRoadmapNavigation={true}
                roadmapNavigationProps={{
                    buttonContinueAction: handleFinishIdentity,
                }}
            >
                <FormattedText value="messagesScreen-correosFinishContent" />
            </MessagesScreen>
        </div>
    );
};

PostOfficeSuccessView.propTypes = {
    handleFinishIdentity: PropTypes.func.isRequired,
};

export default PostOfficeSuccessView;
